import * as React from 'react';
import { inject, observer } from 'mobx-react';
import MeetingModal from '@/models/meeting';
import Style from './index.less';
import RTCInstance from '@/models/rtc';
import { getAvatarStr } from '@/utils/common';

const defaultImage = require('@/assets/default_blue_avatar.png');

export type AvatarType = 'micOn' | 'micOff' | 'cover' | 'speaking';
export interface AvatarProps {
  avatarId?: number;
  yxuid?: string;
  url?: string;
  size: number;
  type: AvatarType;
  meeting?: MeetingModal;
  style?: any;
  className?: string;
  imageSize?: number;
  rtc?: RTCInstance;
  name: string;
}

const Avatar: React.FC<AvatarProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    rtc: store.rtc,
  };
})(
  observer(props => {
    const { size, style, className, name, url } = props;
    const [avatar, setAvatar] = React.useState<string>('');

    React.useEffect(() => {
      if (url) {
        setAvatar(url);
      } else {
        const str = getAvatarStr((name ?? '').trim());
        setAvatar(str);
      }
    }, [name, url]);

    const [errImage, handleImageErrored] = React.useState(defaultImage);

    const fontSize = React.useMemo(() => {
      if (name && /^[A-Z]$/.test(avatar)) {
        return (332 / 800) * size;
      }
      return (284 / 800) * size;
    }, [name, size, avatar]);

    return (
      <div
        className={`${Style['avatar-wrap']} ${className}`}
        style={{ width: `${size}px`, height: `${size}px`, fontSize: `${fontSize > 12 ? fontSize : 12}px`, ...style }}
      >
        {name && !url ? (
          <span
            style={
              fontSize > 12
                ? {}
                : {
                    transform: `scale(${fontSize / 12})`,
                  }
            }
          >
            {avatar}
          </span>
        ) : (
          <img src={avatar || errImage} alt="" />
        )}
      </div>
    );
  }),
);

export default Avatar;
